import { PrimaryButton } from '@systemeio/ui'
import {
  FunnelPageTemplateId,
  FunnelPageTemplateInterface,
} from 'modules/funnels/funnel/types/funnel-page-template-interface'
import { FunnelStepPageId } from 'modules/funnels/funnel/types/funnel-step-interface'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import React from 'react'

interface TemplateCardProps {
  template: FunnelPageTemplateInterface
  onSelect: (id: FunnelPageTemplateId) => Promise<void>
  selectedPageTemplate?: FunnelStepPageId
  onClickCard?: () => void
  isFetching: boolean
}

function TemplateCard({
  template,
  onSelect,
  selectedPageTemplate,
  onClickCard,
  isFetching,
}: TemplateCardProps) {
  const { t } = useLocoTranslation()
  const isTemplateSelected = template.id === selectedPageTemplate

  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  return (
    <div
      className="bg-background-secondary overflow-hidden rounded-xl shadow-lg ring-1 ring-black/5"
      onClick={onClickCard}
    >
      <div className="group relative m-0 aspect-video overflow-hidden p-0">
        <div
          className={`z-1 h-full w-full ${
            isTemplateSelected ? 'flex' : 'hidden'
          } bg-text-primary/50 absolute items-center justify-center gap-5 group-hover:flex group-active:flex `}
        >
          <PrimaryButton
            type={'button'}
            isFetching={isFetching}
            data-test-element={`select-template-${template.id}`}
            onClick={async (e: React.MouseEvent<HTMLButtonElement>) => {
              handleButtonClick(e)
              await onSelect(template.id)
            }}
          >
            <span className={'flex'}>{t('global.select')}</span>
          </PrimaryButton>
          <PrimaryButton
            as={LinkWithoutPrefetch}
            type={'button'}
            href={`/page/template/${template.id}/show`}
            target={'_blank'}
            data-test-element={`preview-template-${template.id}`}
            onClick={handleButtonClick}
          >
            <span className={'flex'}>
              {t('dashboard.funnel.configuration.templates.preview_template')}
            </span>
          </PrimaryButton>
        </div>
        <img
          alt={template.previewImage.filename}
          src={template.previewImage.path}
          data-test-element={template.name}
          className="w-[-webkit-fill-available]"
        />
      </div>
    </div>
  )
}

export default TemplateCard
